const ADD_MESSAGE = 'chat/ADD-MESSAGE'

let initialState = {
  dialogs: {
    alex: {
      name: 'alex',
      newMessage: '',
      message: 'Hi bro!',
      id: '1',
      avatar: 'https://usnd.to/j44L',
      messages: {
        in: ['ggg', 'ssss'],
        out: ['hi']
      },
    },
    vika: {
      name: 'vika',
      newMessage: '',
      message: 'Hi bro!',
      id: '2',
      avatar: 'https://usnd.to/j44i',
      messages: {
        in: ['ggg'],
        out: []
      },
    },
    den: {
      name: 'den',
      newMessage: '',
      message: 'Hi bro!',
      id: '3',
      avatar: 'https://usnd.to/j4q9',
      messages: {
        in: ['ggg'],
        out: []
      },
    },
    greg: {
      name: 'greg',
      newMessage: '',
      message: 'Hi bro!',
      id: '4',
      avatar: 'https://usnd.to/j4qa',
      messages: {
        in: ['ggg'],
        out: []
      },
    },
  }
}
const dialogReducer = (state = initialState, action) => {

  switch (action.type) {
    case ADD_MESSAGE: {
      return {
        ...state,
        dialogs: {
          ...state.dialogs,
          [action.name]: {
            ...state.dialogs[action.name],
            messages: {
              in: [...state.dialogs[action.name].messages.in],
              out: [...state.dialogs[action.name].messages.out, action.message],
            },
          }
        },
      }
    }
    default:
      return state;
  }
}

export const addMessage = (name, message) => ({ type: ADD_MESSAGE, name, message })

export default dialogReducer;